import { render } from "./uploadZBFXList.vue?vue&type=template&id=663a51ed&scoped=true"
import script from "./uploadZBFXList.vue?vue&type=script&lang=js"
export * from "./uploadZBFXList.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Work\\GPTWeb\\licCode\\lic\\webviewer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-663a51ed"]])

export default __exports__